import { __rest } from "tslib";
import React from 'react';
import VeltRecorderControlPanelFloatingModeWireframe from './VeltRecorderControlPanelFloatingModeWireframe/VeltRecorderControlPanelFloatingModeWireframe';
import VeltRecorderControlPanelThreadModeWireframe from './VeltRecorderControlPanelThreadModeWireframe/VeltRecorderControlPanelThreadModeWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltRecorderControlPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltRecorderControlPanelWireframe.FloatingMode = VeltRecorderControlPanelFloatingModeWireframe;
VeltRecorderControlPanelWireframe.ThreadMode = VeltRecorderControlPanelThreadModeWireframe;
export default VeltRecorderControlPanelWireframe;
